var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 18",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.414,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.335 2.892a8.718 8.718 0 000 12.33 8.717 8.717 0 0012.33 0 8.717 8.717 0 000-12.33 8.718 8.718 0 00-12.33 0zm10.441 3.28a.423.423 0 010 .597L11.49 9.057l2.286 2.287a.423.423 0 010 .596l-1.391 1.392a.423.423 0 01-.597 0L9.5 11.045l-2.287 2.288a.423.423 0 01-.596 0L5.224 11.94a.423.423 0 010-.596L7.51 9.056 5.224 6.77a.423.423 0 010-.596L6.616 4.78a.423.423 0 01.597 0L9.5 7.068l2.287-2.288a.423.423 0 01.597 0l1.392 1.393z",
    fill: "#d4366a",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.59028e5d63b0136af1cefc0ada2bd0b4.svg";
export { ForwardRef as ReactComponent };